var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWrongOtp = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 75,
    viewBox: "0 0 75 75",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.5,
    cy: 37.5,
    r: 36,
    stroke: "#AD0C2A",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.1149 22.702C52.9936 23.5807 52.9936 25.0053 52.1149 25.884L25.1149 52.884C24.2362 53.7626 22.8116 53.7626 21.9329 52.884C21.0543 52.0053 21.0543 50.5807 21.9329 49.702L48.9329 22.702C49.8116 21.8233 51.2362 21.8233 52.1149 22.702Z",
    fill: "#AD0C2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9329 22.702C22.8116 21.8233 24.2362 21.8233 25.1149 22.702L52.1149 49.702C52.9936 50.5807 52.9936 52.0053 52.1149 52.884C51.2362 53.7626 49.8116 53.7626 48.9329 52.884L21.9329 25.884C21.0543 25.0053 21.0543 23.5807 21.9329 22.702Z",
    fill: "#AD0C2A"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWrongOtp, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wrongOtp.9ebf6e9d.svg";
export { ForwardRef as ReactComponent };